import React from 'react';
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  HStack,
  Text
} from '@chakra-ui/react';

import ClockIcon from '../../../../assets/clock-icon.svg';
import InvestIcon from '../../../../assets/invest-icon.svg';
import CommunityGreenIcon from '../../../../assets/community-green-icon.svg';
import CloseModalIcon from '../../../../assets/close-modal-icon.svg';

const LearnMorePanel = ({ isOpen, onClose }) => {
  const investmentInfo = [
    {
      title: 'Early Bird Advantage',
      detail:
        'Earlier investors get larger shares of the revenue pool. Your share adjusts as new investors join.',
      icon: ClockIcon
    },
    {
      title: 'Revenue Sharing',
      detail:
        "Earn a percentage of the article's ad revenue based on your Seeds investment and timing.",
      icon: InvestIcon
    },
    {
      title: 'Community Impact',
      detail: 'Your investment helps support writers and signals quality content to other readers.',
      icon: CommunityGreenIcon
    }
  ];
  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size={'lg'}>
      <DrawerOverlay />
      <Box overflowY={'auto'} position={'relative'}>
        <DrawerContent pb="env(safe-area-inset-bottom)">
          <DrawerHeader
            m={0}
            pt={6}
            px={{ base: '15px', md: 6 }}
            pb={0}
            flexDirection="column"
            width="100%"
            maxW={'unset'}
          >
            <HStack justify="space-between" pb={2} borderBottom={'1px solid #D1C8C4'}>
              <Text color="growth-green" fontWeight="bold" fontSize={'xl'}>
                How Article Investment Works
              </Text>
              <img
                src={CloseModalIcon}
                onClick={onClose}
                className="h-9 w-9 cursor-pointer hover:opacity-80"
                color="growth-green"
                alt=""
              />
            </HStack>
          </DrawerHeader>

          <DrawerBody id="comments-sidebar-body" px={{ base: '15px', md: 6 }} pb={4} pt={6}>
            <div className="flex flex-col gap-6">
              {investmentInfo.map((item, index) => (
                <div key={index} className="flex flex-col gap-2">
                  <div className="flex gap-4">
                    <img src={item.icon} alt="icon" className="w-8 h-8" />
                    <div className="flex flex-col">
                      <p className="text-lg font-[800]">{item.title}</p>
                      <p className="text-lg">{item.detail}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </DrawerBody>
        </DrawerContent>
      </Box>
    </Drawer>
  );
};

export default LearnMorePanel;
